import { useState } from 'react'
import { SplitButton as SButton, SplitButtonItem } from '@progress/kendo-react-buttons';
import './SplitButton.scss';

interface ISplitButton {
  options: any;
  onClick: (event: any) => void;
  defaultValue: string;
  defaultIcon?: string;
  onSelect?: boolean;
}

/**
 *
 * @param options object[] - array of objects containing text, and optional icon properties
 * @param onClick () = void; - function to handle button click behavior
 * @param defaultValue string - value show as selected by default
 * @param defaultIcon string? - icon to show by default if passed in
 * @param onSelect boolean? - used if you want to trigger the onclick function when selecting an option from the dropdown
 * @returns React.Component
 * @example
 * <SplitButton
      options={[{ text: 'Download PDF', icon: 'pdf' }, { text: 'Download HTML', icon: 'html' }]}
      onClick={handleDownload}
      defaultValue='Download PDF'
      defaultIcon='pdf'
    // onSelect
    />
 */
const SplitButton = (props: ISplitButton) => {
  const { defaultValue, options, onClick, defaultIcon, onSelect } = props;
  const [selectedOption, setSelectedOption] = useState<string>(defaultValue);
  const [selectedIcon, setSelectedIcon] = useState<string>(defaultIcon ?? '');

  const selectOption = (event: any) => {
    setSelectedOption(event.item.text);
    setSelectedIcon(event.item.icon ?? '');
    if (onSelect) {
      onClick(event.item.text);
    }
  }

  return (
    <SButton
      text={selectedOption}
      onItemClick={(event: any) => selectOption(event)}
      onButtonClick={() => onClick(selectedOption)}
      icon={selectedIcon ?? defaultIcon ?? ''}
      themeColor="base"
      className="split-button"
    >
      {options.map((item: any, index: number) => {
        if (item.icon) {
          return (
            <SplitButtonItem text={item.text} icon={item.icon} key={item.text + index} />
          );
        } else {
          return (
            <SplitButtonItem text={item.text} key={item.text + index} />
          );
        }
      })}
    </SButton>
  )
}

export default SplitButton